"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HR = (0, _styledComponents["default"])('hr').withConfig({
  displayName: "hr__HR",
  componentId: "sc-1t6301w-0"
})(["border:0;height:1px;background:", ";"], function (props) {
  return props.theme.colors.slate.lightest;
});
var _default = HR;
exports["default"] = _default;